export default __webpack_public_path__ + "static/media/card-img-4.327cb11a.png";